import { unMaskCurrency } from '@utils/masks/unMaskCurrency'
import { formattedDatePtBrToIso } from '@utils/dates/formattedDatePtBrToIso'

import type { CreateNewOtherServiceRequestProps } from '@services/api/invoicing/clients/types'
import type { AddEditOtherServicesModalFormProps } from '@pages/Invoicing/components/AddEditOtherServicesModal/form/types'

export const parseAddEditOtherServicePayload = (
  formData: AddEditOtherServicesModalFormProps,
  isInvoicing?: boolean
) => {
  const billingDate = formData.dateOfBilling ? formattedDatePtBrToIso(formData.dateOfBilling) : ''

  const payload: CreateNewOtherServiceRequestProps = {
    idOutrosServicos: formData.serviceId || '',
    branchCode: formData.filiCode || '',
    clientId: formData.clientCode || '',
    clientType: formData.clientType || '',
    clientName: formData.clientName ? (isInvoicing ? formData.clientName : formData.clientName.split(' - ')[1]) : '',
    billingReferenceDate: formData.competenceDate || '',
    description: formData.serviceDescription || '',
    billingStartDate: billingDate,
    startBillingDate: billingDate,
    unitGrossValue: formData.grossUnitValue ? unMaskCurrency(formData.grossUnitValue) : '',
    billingTaxPercentage: formData.tax ? Number(formData.tax.replace(',', '.')) : 0,
    totalQuantity: Number(formData.totalQuantity || 0),
    grossTotalAmount: formData.grossTotalValue ? unMaskCurrency(formData.grossTotalValue) : '',
    netTotalAmount: formData.netTotalValue ? unMaskCurrency(formData.netTotalValue) : '',
    observations: formData.observations || ''
  }

  return payload
}
